var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"64.88 60.5 58.32 60.5 58.32 16.53 19.6 16.53 19.6 9.97 64.88 9.97 64.88 60.5","key":0}),React.createElement("rect",{"x":"1.86","y":"36.2","width":"66.57","height":"6.57","transform":"translate(-17.62 36.44) rotate(-45.03)","key":1})]);
}

Arrow.defaultProps = {"viewBox":"0 0 65 75","width":"13","height":"15","fill":"#fff"};

module.exports = Arrow;

Arrow.default = Arrow;
